// extracted by mini-css-extract-plugin
export default {"icon":"campaign-type_icon__N7Zw6"};